import React from 'react';
import {
  Divider as PodiumDivider,
  Flex,
  Heading,
  Text,
  useMediaQuery,
} from '@podiumhq/design-system';
import styled from 'styled-components/macro';

import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';

import AnimatedRoundedContentBox from '../Trials/layout/AnimatedRoundedContentBox';
import { contentBoxMobileProps } from '../Trials/styles';

const FakeModal = ({
  children,
  marginTop,
  showIcon = true,
  modalWidth,
  padding,
}) => {
  const [isSmallerThan650px] = useMediaQuery('(max-width: 650px)');

  const contentBoxProps = {
    displayLogoIcon: isSmallerThan650px ? showIcon : true,
    margin: isSmallerThan650px
      ? '0'
      : marginTop
      ? `${marginTop}px 18px 18px 18px`
      : '18px',
    padding: '24px',
    ...(isSmallerThan650px && { ...contentBoxMobileProps }),
    ...(modalWidth && { width: modalWidth }),
    ...(padding && { padding: padding }),
  };

  return (
    <Flex justifyContent="center">
      <AnimatedRoundedContentBox {...contentBoxProps}>
        {children}
      </AnimatedRoundedContentBox>
    </Flex>
  );
};

const Divider = () => (
  <StyledPodiumDivider
    width="auto"
    marginLeft="-24px"
    marginRight="-24px"
    marginTop="24px"
    marginBottom="24px"
  />
);

const Header = ({ children }) => (
  <Heading fontWeight="semibold">{children}</Heading>
);
const Body = ({ children }) => <Text>{children}</Text>;

FakeModal.Divider = Divider;
FakeModal.Header = Header;
FakeModal.Body = Body;

export default FakeModal;

const StyledPodiumDivider = styled(PodiumDivider)`
  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    display: none;
  }
`;
